export const LOAD_WALLETS_LIST = 'LOAD_WALLETS_LIST';
export const CREATE_WALLET = 'CREATE_WALLET';
export const RESET_WALLETS = 'RESET_WALLETS';
